import redact from './lib/redact';

export default redact;
export * from './lib/redact';
